'use client';

import { c as _c } from "react/compiler-runtime";
import { BuilderBlocks } from '@builder.io/react';
import 'keen-slider/keen-slider.min.css';
import { useKeenSlider } from 'keen-slider/react';
import { useEffect, useState } from 'react';
import { useResize } from '@src/utils/resize.util';
import { mouseWheelPlugin } from '@src/utils/slider.utils';
import { cn } from '@src/utils/tailwind';
export interface ReviewsProps {
  builderBlock?: {
    id: string;
  };
  slots: Array<{
    name: string;
    content: React.ReactNode;
    width: number;
  }>;
}
export function Reviews(t0) {
  const $ = _c(22);
  const {
    builderBlock,
    slots: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const slots = t2;
  const resize = useResize();
  const [initialSize] = useState(resize);
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      loop: false,
      mode: "free",
      rubberband: false,
      slides: {
        perView: "auto",
        origin: "auto",
        spacing: 0
      }
    };
    t4 = [mouseWheelPlugin];
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  const [sliderRef, instanceRef] = useKeenSlider(t3, t4);
  const [isReady, setIsReady] = useState(false);
  const [centerPadding, setCenterPadding] = useState(0);
  let t5;
  if ($[4] !== instanceRef) {
    t5 = () => {
      const getCenterPadding = function getCenterPadding() {
        if (!instanceRef.current) {
          return 0;
        }
        setIsReady(true);
        const {
          container,
          track
        } = instanceRef.current;
        if (!track.details || track.details.length) {
          return 0;
        }
        return container.clientWidth * (1 - track.details.slidesLength) / 2;
      };
      setCenterPadding(getCenterPadding());
    };
    $[4] = instanceRef;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== instanceRef || $[7] !== resize) {
    t6 = [resize, instanceRef];
    $[6] = instanceRef;
    $[7] = resize;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  useEffect(t5, t6);
  let t7;
  if ($[9] !== slots?.length) {
    t7 = slots?.length === 0 && <div className="keen-slider__slide"><div className="flex h-[200px] flex-col items-center justify-center"><h1 className="text-body-md">Add some reviews</h1></div></div>;
    $[9] = slots?.length;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== builderBlock?.id || $[12] !== centerPadding || $[13] !== initialSize || $[14] !== isReady || $[15] !== resize || $[16] !== slots) {
    t8 = slots?.map((t9, index) => {
      const {
        content,
        width: t10
      } = t9;
      const width = t10 === undefined ? 250 : t10;
      return <div key={index} className={cn(["keen-slider__slide", "box-content flex flex-col items-center justify-center", "border-x-25 border-y-38 border-transparent lg:border-x-50", initialSize.width === resize.width ? "transition-opacity" : "transition-all"])} style={{
        width,
        minWidth: width,
        maxWidth: width,
        marginLeft: index === 0 ? centerPadding : undefined,
        opacity: isReady ? 1 : 0
      }}><BuilderBlocks className="flex w-full flex-col items-center justify-center" parentElementId={builderBlock?.id} dataPath={`component.options.slots.${index}.content`} blocks={content} /></div>;
    });
    $[11] = builderBlock?.id;
    $[12] = centerPadding;
    $[13] = initialSize;
    $[14] = isReady;
    $[15] = resize;
    $[16] = slots;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== sliderRef || $[19] !== t7 || $[20] !== t8) {
    t9 = <div className="bg-bodi-black-text text-white"><div ref={sliderRef} className="keen-slider">{t7}{t8}</div></div>;
    $[18] = sliderRef;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}